import { useEffect, useState } from 'react';
import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect';
const useIsSubsequentRender = mountStrategy => {
  const [isSubsequentRender, setIsSubsequentRender] = useState(false);
  const [useMountEffect] = useState(() => mountStrategy === 'layoutEffect' ? useIsomorphicLayoutEffect : useEffect);
  useMountEffect(() => {
    setIsSubsequentRender(true);
  }, []);
  return isSubsequentRender;
};
export default useIsSubsequentRender;